module.exports = __webpack_public_path__ + "img/pisces.aea20759.svg";